export default "__VITE_ASSET__B0YO0x92__"